import { RootState } from '@store/store.interface';
import { IUserProfile } from '@interfaces/profile';

const getState = (state: RootState) => state.auth.user;
export const userDataSelector = (state: RootState): IUserProfile | null => getState(state).data;
export const userEmailSelector = (state: RootState) => userDataSelector(state)?.email;
